import { Directive, ElementRef, Input } from '@angular/core';
import { NgxPrintDirective } from 'ngx-print';

@Directive({
  selector: '[appCustomPrint]'
})
export class CustomPrintDirective extends NgxPrintDirective {

  private _useExistingCss: boolean = false;

  @Input()
  override get useExistingCss(): boolean {
    return this._useExistingCss;
  }

  override set useExistingCss(value: boolean) {
    this._useExistingCss = value;
  }

  constructor(el: ElementRef) {
    super();
  }

  override print(): void {
    if (this.useExistingCss) {
      // Implement logic to use existing CSS
    }
    super.print();
  }

}
